/*
 * fn: fetchMailer
 *
 * Makes a fetch request to the mailer endpoint
 *
 */
import { EDHRECError } from '@/defs/error'
import { MAILER_URL } from '@/defs/misc'

type Props = {
  attachment?: string
  attachmentName?: string
  attachmentType?: string
  desc: string
  email: string
  gaClientId?: string
  hasEmailConsent: boolean
  history?: {
    length: number
    referrer: string
    url: string
  }
  to: string
}

type ResponseType = {
  errorMessage?: string
}

export const fetchMailer = async (props: Props): Promise<ResponseType> => {
  let response: Response | undefined
  try {
    response = await fetch(MAILER_URL, {
      body: JSON.stringify(props),
      headers: { accept: 'application/json', 'content-type': 'application/json' },
      method: 'post',
    })
  } catch (e) {
    throw new EDHRECError({
      cause: e,
      message: 'Mailer fetch error, please try again.',
      statusCode: 500,
    })
  }

  if (!response.ok) {
    throw new EDHRECError({
      message: 'Mailer response error, please try again.',
      statusCode: response.status,
    })
  }

  let data: ResponseType = {}
  try {
    data = (await response.json()) as ResponseType
  } catch {
    // Ignore if response is empty
  }

  return data
}
